import { render, staticRenderFns } from "./companySet.vue?vue&type=template&id=2351b348&scoped=true&"
import script from "./companySet.vue?vue&type=script&lang=js&"
export * from "./companySet.vue?vue&type=script&lang=js&"
import style0 from "./companySet.vue?vue&type=style&index=0&id=2351b348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351b348",
  null
  
)

export default component.exports